// extracted by mini-css-extract-plugin
export default {"table":"styles_table__tU8WI","tableHeading":"styles_tableHeading__rzpsC","note":"styles_note__DFvxb","check":"styles_check__mX-uR","robotFilter":"styles_robotFilter__7cBUT"};